var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brand"},[_c('section',_vm._l((_vm.list),function(item,index){return _c('dl',{key:index},[_c('dt',[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(item.url),expression:"item.url"}],attrs:{"alt":""}})]),_c('dd',[_vm._v(_vm._s(item.name))]),_c('dd',[_vm._v(_vm._s(item.base))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }